import React from "react";
import { Checkbox, IconButton, styled } from "@mui/material";
import { StyledTableCell } from "../style";
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import StarBorderRoundedIcon from "@mui/icons-material/StarBorderRounded";

const SelectTableCell = styled(StyledTableCell)`
  padding-inline: 2px 0;
`;

export default function Toggle(args) {
  if (typeof args.id !== "string")
    return (
      <SelectTableCell {...args}>
        <IconButton disabled>
          <StarBorderRoundedIcon />
        </IconButton>
      </SelectTableCell>
    );
  return (
    <SelectTableCell {...args}>
      <IconButton onClick={args.onClick}>
        {!!args.content ? <StarRoundedIcon /> : <StarBorderRoundedIcon />}
      </IconButton>
    </SelectTableCell>
  );
}
